import "./style.css";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { gql, useMutation } from "@apollo/client";
import { CREATE_HORSE } from "apollo/mutations/horses";
import { img_upload_base_path } from "constants/constants";
import HorseForm from "../HorseForm";
import ModalStore from "components/Modal/ModalStore";
import OwnershipEmailForm from "./OwnershipEmailForm";
import { Modal, useModalStore } from "stores/modal/useModalStore";
import { useHorseStore } from "stores/horse/useHorseStore";
import { zodResolver } from "@hookform/resolvers/zod";
import { HorseSchema } from "../Schema";

const AddHorse = () => {
  const open = useModalStore((s) => s.open);
  const close = useModalStore((s) => s.close);
  const setHorseName = useHorseStore(action => action.setHorseName);
  const fetchHorseData = useHorseStore(action => action.fetchHorseData);
  const [isLoading, setIsLoading] = useState(false);
  const [addHorse] = useMutation(gql(CREATE_HORSE));

  const methods = useForm({
    resolver: zodResolver(HorseSchema),
    defaultValues: {
      name: "",
      dob: "",
      photo: null,
      discipline: [],
      registeredName: "",
    },
  });

  const onSubmit = async (data) => {
    setIsLoading(true);
    setHorseName(data?.name);

    const photo = data?.photo ? `${img_upload_base_path}${data.photo}` : null;

    const input_horse_data = {
      name: data?.name,
      dob: data?.dob,
      discipline: data?.discipline,
      registeredName: data?.registeredName || "",
      ...(photo ? { photo } : {}),
    };

    try {
      await addHorse({ variables: { input: input_horse_data } });
      fetchHorseData();
      close();
      open(Modal.Congratulation);
    } catch (e) {
      const msg = e?.message || "";
      close();
      if (msg === "Please Verify Your Ownership") {
        ModalStore.openSimpleSuccess({
          icon: undefined,
          fontSize: "40px",
          title: "Please Verify Your Ownership",
          shouldCloseOnOverlayClick: false,
          children: <OwnershipEmailForm inputHorseData={input_horse_data} />,
        });
        return;
      }

      if (msg === "Already Registered Horse With Owner") {
        ModalStore.openSimpleError({
          fontSize: "40px",
          title: "Already Registered Horse With Owner",
          subtitle: "",
          shouldCloseOnOverlayClick: false,
        });
      } else {
        ModalStore.openSimpleError({
          fontSize: "40px",
          title: "An Unexpected Error Occurred",
          description: msg || "Unknown error.",
          shouldCloseOnOverlayClick: false,
        });
      }

      close();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <HorseForm
      onSubmit={onSubmit}
      isLoading={isLoading}
      methods={methods}
      onCancel={close}
    />
  );
};

export default AddHorse;
